module.exports = __webpack_public_path__ + "static/media/adminLOGOa.c627a657.png";